module.exports = __webpack_public_path__ + "img/web-livetalk.b4d868cf.png";